import { atom } from "jotai";

/** Set before cancellation starts so deferred slot locks cannot run after Close. */
export const isBookingWizardClosingAtom = atom(false);
